<!-- Change only the identified area for routes -->

<template>
  <div v-if="useNavbar">
    <nav class="navbar navbar-expand-sm navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
          <div class="navbar-nav">
            <!-- Begin Edit Area - Add or update links -->
            <!-- use the named route pattern -->
            <RouterLink :to="{ name: 'LabView' }" class="nav-link me-3"
              >Lab</RouterLink
            >
            <RouterLink :to="{ name: 'ExportView' }" class="nav-link me-3"
              >Export</RouterLink
            >
            <button class="nav-link me-3" @click="instructionsOffcanvas.show()">
              Support
            </button>

            <RouterLink
              v-if="isAdmin"
              :to="{ name: 'Admin' }"
              class="nav-link me-3"
              >Admin</RouterLink
            >

            <!-- End Edit Area -->
          </div>
        </div>
      </div>
    </nav>
    <!--  Instructions Offcanvas  -->
    <div
      class="offcanvas offcanvas-start bg-main-content"
      tabindex="-1"
      ref="instructionsOffcanvas"
      aria-labelledby="offcanvasExampleLabel"
    >
      <div class="offcanvas-header">
        <h2 class="offcanvas-title" id="offcanvasExampleLabel">
          Technical Support
        </h2>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <SupportForm @submitted="closeModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { Offcanvas } from "bootstrap";

import { mapGetters } from "vuex";

import SupportForm from "@/components/core/SupportForm.vue";

export default {
  name: "TheNavbar",
  components: {
    SupportForm
  },
  data() {
    return {
      instructionsOffcanvas: null
    };
  },
  computed: {
    ...mapGetters(["useNavbar", "isAdmin"])
  },
  methods: {
    closeModal() {
      this.instructionsOffcanvas.hide();
    }
  },
  mounted() {
    this.instructionsOffcanvas = new Offcanvas(
      this.$refs.instructionsOffcanvas
    );
  }
};
</script>

<style scoped>
.offcanvas {
  width: 50rem !important;
}
</style>
